// extracted by mini-css-extract-plugin
module.exports = {"addon-info-model":"addOnInfoModal_addon-info-model__7J90I","title":"addOnInfoModal_title__a9ebz"};